import { create } from "zustand";
import { deleteGalleryImage, deleteImageFormGallery, getGalleryByID, getGalleryImage, getGalleryPage, registerGalleryImage, registerGalleryPage, registerImage } from "../api/gallery";

export const useGalleryStore = create((set, get) => ({
    loading: true,
    banner: null,
    gallery: [],
    selectedGallery: null,
    emergencyServicesGallery: [],
    residentialConcreteGallery: [],
    emergencyServices: null,
    residentialConcrete: null,
    selectedGalleryImage: null,
    imageLength: null,

    getgalleryimage: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true })
            const res = await getGalleryImage(pageNumber, pageSize, search, field)
            set({ gallery: res?.galleries })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    registergalleryimage: async (form, id, sectionId) => {
        try {
            const res = await registerImage(form, id, sectionId)

            if (res) {
                const currentGallery = get().gallery || [];

                if (!sectionId || !res?.image) {
                    console.warn("Missing sectionId or image data in response:", res);
                    return;
                }

                const updatedGallery = currentGallery.map((section) => {
                    if (section._id?.toString() === sectionId.toString()) {
                        return {
                            ...section,
                            image: (res.image || []).sort((a, b) => b.order - a.order),
                        };
                    }
                    return section;
                });

                set({ gallery: updatedGallery });
            }

            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    registergallerypage: async (form, id) => {
        try {
            const res = await registerGalleryPage(form, id)
            if (res) {
                const galleryList = get().gallery || [];

                const filteredGallery = galleryList.filter(
                    (ele) => ele._id.toString() !== id.toString()
                );


                const newSection = {
                    _id: res?._id,
                    image: (res.image || []).sort((a, b) => b.order - a.order),
                    subTitle: res.subTitle || "",
                    title: res.title || "",
                    description: res.description || "",
                    isFeatured: !!res.isFeatured,
                    order: Number(res.order) || 0,
                };


                const updatedGallery = [...filteredGallery, newSection].sort(
                    (a, b) => b.order - a.order
                );

                set({ gallery: updatedGallery });
            }

            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getgallerypage: async () => {
        try {
            const res = await getGalleryPage()
            set({
                emergencyServices: res?.emergencyServices, residentialConcrete: res?.residentialConcrete
            })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    deletegallerySection: async (id) => {
        try {
            set({ loading: true });
            const res = await deleteGalleryImage(id);
            if (res) {
                const currentGallery = get().gallery || [];
                const updatedGallery = currentGallery.filter((ele) => ele._id !== id);

                set({
                    loading: false,
                    gallery: updatedGallery,
                });
            } else {
                set({ loading: false });
            }

            return res;
        } catch (error) {
            console.error("Error in deletegallerySection:", error);
            set({ loading: false });
            return false;
        }
    },
    getGalleryById: async (id) => {
        try {
            const res = await getGalleryByID(id)
            set({ selectedGallery: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getGalleryImageById: (id, imageId) => {
        const gallery = get().gallery.find(ele => ele._id === id);

        if (!gallery) return null;

        const selectedImage = (gallery.image || []).find(ele => ele._id === imageId);
        const imageLength = (gallery.image?.length || 0) + 1;

        set({ selectedGalleryImage: selectedImage, imageLength });

        return { selectedImage, imageLength };
    },
    deleteImageFormGallery: async (sectionId, id) => {
        try {
            set({ loading: true });
            const res = await deleteImageFormGallery(sectionId, id);

            if (res) {
                let galleryList = get().gallery || [];

                const updatedGallery = galleryList.map((section) => {
                    if (section._id === sectionId) {
                        return {
                            ...section,
                            image: section.image.filter((img) => img._id !== id),
                        };
                    }
                    return section;
                });

                set({
                    gallery: updatedGallery,
                    loading: false,
                });
            } else {
                set({ loading: false });
            }

            return res;
        } catch (error) {
            console.error("Error in deleteImageFormGallery:", error);
            set({ loading: false });
            return false;
        }
    },


}));
